import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { slugifyParam } from 'utils/url';
import { wa } from 'apps/analytics';

export default function CouponLink({ id, name, couponId }) {
  function reportFopCouponLinkClicked() {
    wa.triggerPageEventWithDescription('FOP coupon campaign clicked', {
      PER_COUPON_ID: couponId,
    });
  }

  function buildLink() {
    const campaign = slugifyParam(name, id);
    return `/coupons/products?campaigns=${campaign}`;
  }

  return (
    <div className="fop-couponLink">
      <Link
        to={buildLink()}
        className="gn-textLink fop-couponLink__href"
        onClick={reportFopCouponLinkClicked}
      >
        <span className="fop-couponLink__text">
          View all products
        </span><span className="icon icon__chevron-right fop-couponLink__chev" />
      </Link>
    </div>
  );
}

CouponLink.propTypes = {
  couponId: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};
